import Vue from 'vue';
import VueRouter from 'vue-router';
import { Base64 } from 'js-base64';
import store from '../store/index';
import axios from '../services/auth';
import { isDev } from '../lib/config';

/* eslint-disable */
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: { name: 'doctorList' },
  },
  {
    path: '/myPrescription',
    name: 'myPrescription',
    component: () => import('../views/MyPrescription.vue'),
    meta: {
      title: '我的处方',
    },
  },
  {
    path: '/myOrderList',
    name: 'myOrderList',
    component: () => import('../views/MyOrderList.vue'),
    meta: {
      title: '我的订单',
    },
  },
  {
    path: '/doctorList',
    name: 'doctorList',
    component: () => import('../views/DoctorList.vue'),
    meta: {
      title: '名医列表',
    },
  },
  {
    path: '/doctorInfo/:id',
    name: 'doctorInfo',
    component: () => import('../views/DoctorInfo.vue'),
    meta: {
      title: '服务主页',
    },
  },
  {
    path: '/doctorDate',
    name: 'doctorDate',
    component: () => import('../views/doctor/date/index.vue'),
    meta: {
      title: '问诊日期',
    },
  },
  {
    path: '/DoctorComment/:id',
    name: 'DoctorComment',
    component: () => import('../components/DoctorComment.vue'),
    meta: {
      title: '全部评论',
    },
  },
  {
    path: '//:id',
    name: 'doctorInfoTemplate',
    component: () => import('../views/DoctorInfoTemplate.vue'),
    meta: {
      title: '服务主页',
    },
  },
  {
    // id: 医生id
    // money 问诊费用
    path: '/symptomInfo/:id/:money/:serviceItems',
    name: 'symptomInfo',
    component: () => import('../views/SymptomInfo.vue'),
    meta: {
      title: '上传病情资料',
    },
  },
  {
    path: '/confirmService/:id',
    name: 'confirmService',
    component: () => import('../views/ConfirmService.vue'),
    meta: {
      title: '服务确认',
    },
  },
  {
    path: '/orderBuyDrug/:id',
    name: 'orderBuyDrug',
    // component: pageOrderBuyDrug, // 原文件名称
    component: () => import('../views/OrderBuyDrug.vue'),
    meta: {
      title: '预约购药',
    },
  },
  {
    path: '/addressList',
    name: 'addressList',
    // component: pageAddressList,
    component: () => import('../views/AddressList.vue'),
    meta: {
      title: '地址列表',
    },
  },
  {
    path: '/addressItem/:id',
    name: 'addressItem',
    component: () => import('../views/AddressItem.vue'),
    meta: {
      title: '配送地址',
    },
  },
  {
    path: '/prescription/:id',
    name: 'prescription',
    // component: pagePrescription,
    component: () => import('../views/Prescription.vue'),
    meta: {
      title: '处方笺',
    },
  },
  {
    path: '/prescriptionCanvas/:id',
    name: 'prescriptionCanvas',
    // component: pagePrescription,
    component: () => import('../views/prescriptionCanvas.vue'),
    meta: {
      title: '处方笺图片',
    },
  },
  {
    path: '/orderDetail/:id/:orderNum',
    name: 'orderDetail',
    component: () => import('../views/OrderDetail.vue'),
    meta: {
      title: '处方详情',
    },
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('../views/PayWeixin.vue'),
    meta: {
      title: '订单支付',
    },
  },
  {
    path: '/protocol/:type',
    name: 'protocol',
    component: () => import('../views/Protocol.vue'),
    meta: {
      title: '协议',
    },
  },
  {
    path: '/logistics/:id',
    name: 'logistics',
    component: () => import('../views/Logistics.vue'),
    meta: {
      title: '物流信息',
    },
  },
  {
    path: '/consultationList/:id/:money/:serviceItems',
    name: 'consultationList',
    component: () => import('../views/ConsultationList.vue'),
    meta: {
      title: '填写问诊单',
    },
  },
  {
    path: '/consultationListTemplate/:order_code',
    name: 'consultationListTemplate',
    component: () => import('../views/ConsultationListTemplate.vue'),
    meta: {
      title: '填写问诊单', // 模板消息
    },
  },
  {
    path: '/notice/:id',
    name: 'notice',
    component: () => import('../views/notice.vue'),
    meta: {
      title: '公告', // 公告
    },
  },
  {
    path: '/noticeAll/:id',
    name: 'noticeAll',
    component: () => import('../views/noticeAll.vue'),
    meta: {
      title: '平台公告', // 公告
    },
  },
  {
    path: '/NewComments/:id',
    name: 'NewComments',
    component: () => import('../views/NewComments.vue'),
    meta: {
      title: '医生评价', // 医生评价
    },
  },
  {
    path: '/saleLogin',
    name: 'saleLogin',
    component: () => import('../views/saleLogin.vue'),
    meta: {
      title: '销售登陆',
    },
  },
  {
    path: '/patientManagementList/:id',
    name: 'patientManagementList',
    component: () => import('../views/patientManagementList.vue'),
    meta: {
      title: '患者列表',
    },
  },

  {
    path: '/patientManagement',
    name: 'patientManagement',
    component: () => import('../views/patientManagement.vue'),
    meta: {
      title: '录入资料',
    },
  },
  {
    path: '/patientManagementUpdate',
    name: 'patientManagementUpdate',
    component: () => import('../views/patientManagementUpdate.vue'),
    meta: {
      title: '查看资料',
    },
  },
  {
    path: '/information-index',
    name: 'information-index',
    component: () => import('../views/information/index.vue'),
    meta: {
      title: '患者资料',
    },
  },
  {
    path: '/information-edit',
    name: 'information-edit',
    component: () => import('../views/information/edit.vue'),
    meta: {
      title: '新增患者资料',
    },
  },
  {
    path: '/serviceDetil/:id',
    name: 'serviceDetil',
    component: () => import('../views/serviceDetil.vue'),
    meta: {
      title: '咨询订单详情',
    },
  },
  {
    path: '/pennant-list',
    name: 'pennantList',
    component: () => import('../views/pennant/list.vue'),
    meta: {
      title: '患者感谢',
    },
  },
  {
    path: '/pennant-create',
    name: 'pennantCreate',
    component: () => import('../views/pennant/create.vue'),
    meta: {
      title: '感谢患者',
    },
  },
  {
    path: '/pennant-qr-code',
    name: 'pennantQrcode',
    component: () => import('../views/pennant/qr-code.vue'),
    meta: {
      title: '感谢患者',
    },
  },
  {
    path: '/IGU-details',
    name: 'IGUdetails',
    component: () => import('../views/IGU/details.vue'),
    meta: {
      title: '艾拉莫德',
    },
  },
  {
    path: '/IGU-create',
    name: 'IGUcreate',
    component: () => import('../views/IGU/create.vue'),
    meta: {
      title: '艾拉莫德',
    },
  },
  {
    path: '/IGU-list',
    name: 'IGUList',
    component: () => import('../views/IGU/list.vue'),
    meta: {
      title: '艾拉莫德',
    },
  },
  {
    path: '/shopping-list',
    name: 'shoppingList',
    component: () => import('../views/shopping/list.vue'),
    meta: {
      title: '商城列表',
    },
  },
  {
    path: '/shopping-cart',
    name: 'shoppingCart',
    component: () => import('../views/shopping/cart.vue'),
    meta: {
      title: '购物车',
    },
  },
  {
    path: '/shopping-order-list',
    name: 'shoppingOrderList',
    component: () => import('../views/shopping/order-list.vue'),
    meta: {
      title: '订单列表',
    },
  },
  {
    path: '/shopping-order-detail',
    name: 'shoppingOrderDetail',
    component: () => import('../views/shopping/order-detail.vue'),
    meta: {
      title: '订单详情',
    },
  },
  {
    path: '/addPenant',
    name: 'addPenant',
    component: () => import('../views/IGU/addPenant.vue'),
    meta: {
      title: '艾拉莫德',
    },
  },
  {
    path: '/shopping-address-list',
    name: 'shopAddressList',
    component: () => import('../views/shopping/address-list.vue'),
    meta: {
      title: '地址列表',
    },
  },
  {
    path: '/shopping-address-detail',
    name: 'shopAddressDetail',
    component: () => import('../views/shopping/address-detail.vue'),
    meta: {
      title: '地址修改',
    },
  },
  {
    path: '/shopping-pay',
    name: 'shopPay',
    component: () => import('../views/shopping/shop-pay.vue'),
    meta: {
      title: '订单支付',
    },
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});
console.log(router);
// eslint-disable-next-line
// URL参数值获取getQueryString
const getQueryString = (name) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return '';
};

/*
* open_id: o-4FEt_KNjg8d3Ex-QltqpumXvFs  系统id: 26667752789901991
* open_id: o-4FEtxOLLldZq_IEGaW_ywMBHzE  系统id: 26667752789901992

新的
* open_id: o_05xv3hrEb64szX-ih7mJ3G6vKw  系统id: 26210419135742009

* */
// 路由发生变化修改页面title

router.beforeEach((to, from, next) => {
  let open_id = '';

  // 不知道为什么要在这里做
  if (isDev) {
    open_id = 'o_05xv3hrEb64szX-ih7mJ3G6vKw';
    // store.state.userInfo.patientId = '26210419135742009'; //荣华
    // store.state.userInfo.patientId = '26210419135742009'; //荣华（正式服）
    // store.state.userInfo.patientId = '27719976693878496'; //miki
    store.state.userInfo.patientId = '26667752789981430'; //miki测试服2
    // store.state.userInfo.patientId = '27719976694010386'; //患者
    // store.state.userInfo.patientId = '26210419135783429'; // 正式服的我的号
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // console.log(window.location);
  // 路由守卫，进入时需先检查是否有patientId

  if (!store.state.userInfo.patientId) {
    open_id = getQueryString('open_id');
    // eslint-disable-next-line
    console.log('openId', open_id);
    // open_id = 'o_05xv66hGhPxtRwIk87ODZUn8_M';
    // open_id = 'o-4FEtxOLLldZq_IEGaW_ywMBHzE';
    if (!open_id) {
      const path = window.location.hash;
      const encodePath = Base64.encode(path);
      console.log(encodePath);
      // 测试环境
      const WXCodeUrl = `http://wwfs.wenwenfengshi.com/WX/WX?backUrl=${encodePath}`;
      // 线上环境
      // const WXCodeUrl = `https://api.wenwenfs.com/WX/WX?backUrl=${encodePath}`;
      // eslint-disable-next-line
      window.location.href = WXCodeUrl;
    } else {
      axios.getUserAddressById({ open_id }).then((res) => {
        if (res.data.status == 'success') {
          const patientId = res.data.data.patient_id;
          store.commit('setPatientId', patientId);
          next();
        }
      });
    }
  } else {
    next();
  }
});
// 路由重复报错问题解决方法
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
